import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { getAuth } from "firebase/auth";
import "./VerifyEmail.css";
import { motion } from "framer-motion";
import { BiRefresh } from "react-icons/bi";

function VerifyEmail() {
  useEffect(() => {
    setUser(getAuth());
    setLoad(true);
  });
  const [user, setUser] = useState([]);
  const [load, setLoad] = useState(false);
  console.log(user);
  if (load === true) {
    if (user.currentUser) {
      if (user.currentUser.emailVerified) {
        return <Redirect to="/menu"></Redirect>;
      }
    }
  }
  function refreshPage() {
    window.location.reload(false);
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="verify_conteiner"
    >
      <div className="verify_div">
        We sent an email to your email! Verify this for continue!
        <p>Refresh the page when you are done!</p>
        <button
          onClick={refreshPage}
          style={{
            marginTop: "5%",
            color: "wheat",
            display: "flex",
            alignItems: "center",
            border: "1px solid",
            borderRadius: "5px",
            padding: "1% 2%",
            marginLeft: "37%",
          }}
        >
          <BiRefresh />
          Refresh
        </button>
      </div>
    </motion.div>
  );
}

export default VerifyEmail;
